import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { commonCodeListAPI, getGeoIPAPI } from '../api/commonAPI';
import { setUserInfo } from '../redux/logData';

export default function useCommonCode(upCd){
  const logDispatch = useDispatch();
  const [codeList, setCodeList] = useState(null);

  const codeListAPICall = useCallback(async (upCd) => {
    if (!upCd) return;

    try {
      const resp = await commonCodeListAPI(upCd);
      setCodeList(resp);
    } catch (e) {
      if (e && e.code) {
        alert(`error code: ${e.code}`);
      }
      setCodeList(null);
    }
  }, []);

  useEffect(() => {
    codeListAPICall(upCd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [upCd]);

  const getGeoIPAPICall = useCallback(async () => {
    try {
      const res = await getGeoIPAPI({
        // IP 주소 맵핑된 해당 국가코드 조회
        ipAddr: "",
      });
      logDispatch(setUserInfo({
        ipAddress: res.ipAddress
      }))
    } catch (error) {
      console.log("##### getGeoIPAPICall error: ", error);
    }
  }, [])

  return { codeList, getGeoIPAPICall }

}
